export default __webpack_public_path__ + "static/media/warning--emergency-vehicles--g1.11cfb237.png";